export default "__VITE_ASSET__74309ab8__"